import { useMutation } from "react-query";
import IssueSN from "../services/IssueSN";

function useIssueSN() {
  return useMutation(["issue-sn"], IssueSN);
}

export default useIssueSN;
